import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import $ from "jquery";
import useAlertFromLocation from "../../../../hooks/useAlertFromLocation";
import useDeleteData from "../../../../hooks/useDeleteData";
import { ProgressSpinner } from "primereact/progressspinner";
import Select from "react-select";

const ProductionAndTransferReport = () => {
  const [planningData, setPlanningData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");
  const [userDepartment, setUserDepartment] = useState("");
  const [inputs, setInputs] = useState({});
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get("/production-and-transfer-list");
      setPlanningData(res.data);

      Http.get("/staff-type-check").then((res) => {
        setRole(res.data);
      });
      Http.get("/me").then((res) => {
        setUserDepartment(res.data.data.department_art_id);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await Http.get("/departmentArtSelect2");
      setDepartments(res.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchDepartments();
    const today = new Date().toISOString().split("T")[0];
    setSelectedDate(today);
    setInputs({
      date: today,
    });
    $("body").addClass("collapse-menu");
  }, []);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const handleDepartmentChange = (selectedOption) => {
    setSelectedDepartment(selectedOption);
    setInputs({ ...inputs, department_id: selectedOption ? selectedOption.value : null });
  };

  const handleSearch = () => {
    setLoading(true);
    let url = `/production-and-transfer-list?date=${inputs.date}`;
    
    // Add department_id parameter if a department is selected
    if (inputs.department_id) {
      url += `&department_id=${inputs.department_id}`;
    }
    
    Http.get(url)
      .then((res) => {
        setPlanningData(res.data);
        navigate("/production-and-transfer-report", {
          state: { message: res.data.message, type: "success" },
        });
        setLoading(false);
      })
      .catch(function (e) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: e.response.data.message,
        });
      });
  };

  // Helper function to format values
  const formatValue = (value) => {
    if (value === null || value === undefined) return "-";
    if (typeof value === "number") return value.toString();
    return value;
  };

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Production and Transfer Report</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="d-flex align-items-center justify-content-center">
              <div className="col-lg-2">
                <div className="form-group">
                  <label htmlFor="">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    defaultValue={selectedDate}
                    onChange={handleDateChange}
                  />
                </div>
              </div>
              {role === "planning" && (
                <div className="col-lg-3">
                  <div className="form-group">
                    <label htmlFor="">Department</label>
                    <Select
                      value={selectedDepartment}
                      onChange={handleDepartmentChange}
                      options={departments}
                      isClearable
                      placeholder="Select Department"
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  </div>
                </div>
              )}
              <div className="col-lg-1">
                <div className="form-group mt-4">
                  <button className="btn btn-primary" onClick={handleSearch}>
                    Search
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body bg-gray-200 table-responsive">
              {loading ? (
                <ProgressSpinner />
              ) : (
                <>
                  {planningData.length > 0 ? (
                    <table className="table table-bordered table-sm border-collapse border border-gray-300 w-full">
                      <thead>
                        <tr>
                          {/* Product Information */}
                          <th rowSpan="2">Code</th>
                          <th rowSpan="2">Product Name</th>
                          <th rowSpan="2">Unit</th>
                          <th rowSpan="2">Company</th>
                          <th rowSpan="2">Shape</th>
                          <th rowSpan="2">Decoration Code</th>
                          <th rowSpan="2">Decoration Name</th>
                          <th rowSpan="2">Color</th>

                          {/* Production Data */}
                          <th colSpan="18" className="text-center">
                            Production Data
                          </th>
                           {/* Loss Data */}
                          <th colSpan="2" className="text-center">
                            C Class Defect
                          </th>
                          {/* Transfer Data */}
                          <th colSpan="16" className="text-center">
                            Transfer Data
                          </th>

                           

                          {/* Loss Data */}
                          <th colSpan="11" className="text-center">
                            Loss Data
                          </th>
                        </tr>
                        <tr>
                          {/* Production Data Subheaders */}
                          <th>Slice Weight</th>
                          <th>Green Weight</th>
                          <th>Biscuit Weight</th>
                          <th>Glost Weight</th>
                          <th>FG Weight</th>
                          <th>Qty</th>
                          <th>Load Qty</th>
                          <th>Export Qty</th>
                          <th>A Class</th>
                          <th>B Class</th>
                          <th>C Class</th>
                          <th>Return qty</th>
                          <th>Inner qty</th>
                          <th>Master qty</th>
                          <th>loss qty</th>
                          <th>loss qty a</th>
                          <th>loss qty b</th>
                          <th>loss qty c</th>

                          <th>Type</th>
                          <th>Qty</th>

                          {/* Transfer Data Subheaders */}
                          <th>Green Weight</th>
                          <th>Biscuit Weight</th>
                          <th>Glost Weight</th>
                          <th>FG Weight</th>
                          <th>Delivery Qty</th>
                          <th>Repair Qty</th>
                          <th>Delivery Qty Export</th>
                          <th>Delivery A Class</th>
                          <th>Delivery B Class</th>
                          <th>Delivery C Class</th>
                          <th>Delivery Inner qty</th>
                          <th>Delivery Master qty</th>
                          <th>Delivery loss Export</th>
                          <th>Delivery loss qty a</th>
                          <th>Delivery loss qty b</th>
                          <th>Delivery loss qty c</th>

                         

                          {/* Loss Data Subheaders */}
                          <th>Load Loss Qty</th>
                          <th>Before Loss Qty</th>
                          <th>After Loss Qty</th>
                          <th>Before Export</th>
                          <th>After Export</th>
                          <th>Before A Class</th>
                          <th>After A Class</th>
                          <th>Before B Class</th>
                          <th>After B Class</th>
                          <th>Before C Class</th>
                          <th>After C Class</th>
                        </tr>
                      </thead>
                      <tbody>
                        {planningData.map((item, index) => {
                          const productions = item.production_data || [];
                          const transfers = item.transfer_data || [];
                          const losses = item.loss_data || [];
                          const c_class_defect_details = item.c_class_defect_details || [];

                          const maxLength = Math.max(
                            productions.length,
                            transfers.length,
                            losses.length,
                            c_class_defect_details.length,
                          );

                          return [...Array(maxLength)].map((_, i) => {
                            const production = productions[i] || {};
                            const transfer = transfers[i] || {};
                            const loss = losses[i] || {};
                            const c_class_defect_detail = c_class_defect_details[i] || {};

                            return (
                              <tr key={`${index}-${i}`}>
                                {/* Product Information with rowSpan */}
                                {i === 0 ? (
                                  <>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.product_code)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.product_name)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.unit)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.company)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.shape)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.decoration_code)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.decoration_name)}
                                    </td>
                                    <td rowSpan={maxLength}>
                                      {formatValue(item.color)}
                                    </td>
                                  </>
                                ) : null}

                                {/* Production Data */}
                                <td>{formatValue(production.slice_weight)}</td>
                                <td>{formatValue(production.green_weight)}</td>
                                <td>
                                  {formatValue(production.biscuit_weight)}
                                </td>
                                <td>{formatValue(production.glost_weight)}</td>
                                <td>{formatValue(production.fg_weight)}</td>
                                <td>{formatValue(production.qty)}</td>
                                <td>{formatValue(production.load_qty)}</td>
                                <td>{formatValue(production.qty_export)}</td>
                                <td>{formatValue(production.qty_a_class)}</td>
                                <td>{formatValue(production.qty_b_class)}</td>
                                <td>{formatValue(production.qty_c_class)}</td>
                                <td>{formatValue(transfer.is_return == 1 ? transfer.delivery_qty : 0)}</td>
                                <td>{formatValue(production.inner_qty)}</td>
                                <td>{formatValue(production.master_qty)}</td>
                                <td>{formatValue(production.loss_qty)}</td>
                                <td>{formatValue(production.loss_qty_a)}</td>
                                <td>{formatValue(production.loss_qty_b)}</td>
                                <td>{formatValue(production.loss_qty_c)}</td>

                                <td>{formatValue(c_class_defect_detail.type)}</td>
                                <td>{formatValue(c_class_defect_detail.qty)}</td>

                                {transfer.is_return == 0 ? (
                                  <>
                                    {/* Transfer Data */}
                                    <td>
                                      {formatValue(transfer.green_weight)}
                                    </td>
                                    <td>
                                      {formatValue(transfer.biscuit_weight)}
                                    </td>
                                    <td>
                                      {formatValue(transfer.glost_weight)}
                                    </td>
                                    <td>{formatValue(transfer.fg_weight)}</td>
                                    <td>
                                      {formatValue(transfer.is_repair != 1 && transfer.delivery_qty)}
                                    </td>
                                    <td>
                                      {formatValue(transfer.is_repair == 1 && transfer.delivery_qty)}
                                    </td>
                                    <td>
                                      {formatValue(
                                        transfer.delivery_qty_export
                                      )}
                                    </td>
                                    <td>
                                      {formatValue(
                                        transfer.delivery_qty_a_class
                                      )}
                                    </td>
                                    <td>
                                      {formatValue(
                                        transfer.delivery_qty_b_class
                                      )}
                                    </td>
                                    <td>
                                      {formatValue(
                                        transfer.delivery_qty_c_class
                                      )}
                                    </td>
                                    <td>
                                      {formatValue(transfer.delivery_inner_qty)}
                                    </td>
                                    <td>
                                      {formatValue(
                                        transfer.delivery_master_qty
                                      )}
                                    </td>
                                    <td>
                                      {formatValue(transfer.loss_qty_export)}
                                    </td>
                                    <td>
                                      {formatValue(transfer.loss_qty_a_class)}
                                    </td>
                                    <td>
                                      {formatValue(transfer.loss_qty_b_class)}
                                    </td>
                                    <td>
                                      {formatValue(transfer.loss_qty_c_class)}
                                    </td>
                                  </>
                                ): (
                                  <>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                  </>
                                )}

                                {/* Loss Data */}
                                <td>{formatValue(loss.load_loss_qty)}</td>
                                <td>
                                  {formatValue(loss.before_production_loss_qty)}
                                </td>
                                <td>
                                  {formatValue(loss.after_production_loss_qty)}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.before_production_loss_qty_export
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.after_production_loss_qty_export
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.before_production_loss_qty_a_class
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.after_production_loss_qty_a_class
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.before_production_loss_qty_b_class
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.after_production_loss_qty_b_class
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.before_production_loss_qty_c_class
                                  )}
                                </td>
                                <td>
                                  {formatValue(
                                    loss.after_production_loss_qty_c_class
                                  )}
                                </td>
                              </tr>
                            );
                          });
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <p style={{ textAlign: "center", color: "gray" }}>
                      No records found
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductionAndTransferReport;
